import { Component, OnInit } from '@angular/core';
import { topicMaster } from '../../../Models/TopicMasterModel';
import { CheckAuth } from '../../../Services/UtilityService';
import { AdminTopicMasterServices } from '../../../Services/Admin/TopicMaster';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-manage-topic-list',
  templateUrl: './manage-topic-list.component.html',
  styleUrls: ['./manage-topic-list.component.css']
})
export class ManageTopicListComponent implements OnInit {
  tokenKey: string = '';
  topicMaster: topicMaster[] = [];
  statusCode: number = 0;
  totalPageSize: number = 0;
  pageSize: number = 0;
  pageIndex: number = 0;
  orderBy: string = 'null';
  whereCondition: string = 'null';
  deleteId: string = '0';
  isAscending: boolean;
  refreshTable: boolean = true;
  upDowTopicNameCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowDisplayOrderCSS: string = '';
  // Message 
  isErrorMessage: boolean = false;
  errorMessage: string = '';

  constructor(private toastr: ToastrService, private checkAuth: CheckAuth, private topicServices: AdminTopicMasterServices, private router: Router) {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
  }

  ngOnInit() {
    this.refreshTable = true;
    this.pageSize = 10;
    this.totalPageSize = 1;
    this.pageIndex = 1;
    this.whereCondition = 'null';
    this.orderBy = 'DisplayOrder DESC';
    this.isAscending = false;
    this.GetTopicMaster();
    this.showErrorMessage();
  }

  showErrorMessage() {
    debugger;
    if (sessionStorage.getItem("TopicCRUDStatus") !== null) {
      if (sessionStorage.getItem("TopicCRUDStatus") === 'Added') {
        this.showMessage('Topic added successfully', 'Added', 'success');
        sessionStorage.removeItem('TopicCRUDStatus');
      }
      else if (sessionStorage.getItem("TopicCRUDStatus") === 'Edited') {
        this.showMessage('Topic updated successfully', 'Edited', 'success');
        sessionStorage.removeItem('TopicCRUDStatus');
      }
    }
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetTopicMaster(): void {
    this.topicServices.GetTopicMaster(this.tokenKey, this.pageIndex.toString(), this.pageSize.toString(), this.whereCondition, this.orderBy).subscribe(
      data => {
        debugger;
        this.topicMaster = data["topic"];
        if (this.topicMaster.length > 0)
          this.totalPageSize = parseInt(this.topicMaster[0].totalRecords);
      },
      error => this.statusCode = error,
    );
  }

  pageChanged($event) {
    this.pageIndex = parseInt($event.page);
    this.GetTopicMaster();
  }

  setTopicId(Id: string) {
    this.deleteId = Id;
  }

  editTopicMaster(id: string) {
    debugger;
    let navigation = '/admin/topic/edit/' + id;
    this.router.navigate([navigation]);
  }

  sort(sortBy: string) {
    debugger;

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "TopicName") {
        this.upDowTopicNameCSS = 'fa fa-arrow-up';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowTopicNameCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "DisplayOrder") {
        this.upDowTopicNameCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = 'fa fa-arrow-up';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "TopicName") {
        this.upDowTopicNameCSS = 'fa fa-arrow-down';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowTopicNameCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "DisplayOrder") {
        this.upDowTopicNameCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = 'fa fa-arrow-down';
      }
    }
    this.GetTopicMaster();
  }

  deleteTopic(deleteId: any) {
    if (deleteId != null && deleteId != "") {
      this.topicServices.DeleteTopicMaster(this.tokenKey, this.deleteId).subscribe(
        data => {
          this.pageSize = 10;
          this.totalPageSize = 1;
          this.pageIndex = 1;
          this.whereCondition = 'null';
          this.orderBy = 'DisplayOrder DESC';
          this.isAscending = false;
          this.GetTopicMaster();
          this.refreshGrid();
          this.showMessage('Topic deleted successfully', 'Deleted', 'success');
        },
        error => this.statusCode = error,
      );
    }
    else{
      
    }

  }

  refreshGrid(): void {
    this.refreshTable = false;
    setTimeout(() => {
      this.refreshTable = true;
      this.pageIndex = 1;
    }, 10);
  }
}
